import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import withUser from 'login/withUser';
import { maxNumberOfRecents } from 'config.jsx';


const styles = theme => ({
  AccountAndRecents: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingRight: '5px',
  },
  LoggedInStatus: {
    color: 'white',
    textAlign: 'right',
    paddingRight: '8px',
    whiteSpace: 'nowrap',
  },
  Buttons: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  Icon: {
    color: theme.palette.primary.main,
    fontSize: '1.03rem',
  },
  Button: {
    margin: '5px',
    minWidth: '36px',
  },
  buttonLabel: {
    marginLeft: '7px',
  },
});

export class AccountAndRecents extends React.Component {
  constructor(props) {
    super(props);

    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.handleRecentClicked = this.handleRecentClicked.bind(this);
    this.updateRecents = this.updateRecents.bind(this);

    this.state = {
      anchorEl: null,
    };
  }

  componentDidMount() {
    const { elephant } = this.props;
    this.updateRecents(elephant);
  }

  componentDidUpdate(prevProps) {
    const { elephant } = this.props;
    if (!elephant) return;

    if (!prevProps.elephant || prevProps.elephant.pk !== elephant.pk) {
      this.updateRecents(elephant);
    }
  }

  openMenu(event) {
    this.setState({ anchorEl: event.currentTarget });
  }

  closeMenu() {
    this.setState({ anchorEl: null });
  }

  handleRecentClicked(event) {
    this.closeMenu();
    const { updateActiveElephant } = this.props;
    const recents = JSON.parse(localStorage.getItem('recentElephants'));

    const recentIndex = event.target.getAttribute('recent-index');
    const elephantClicked = recents[recentIndex];
    updateActiveElephant(elephantClicked.pk);
  }

  updateRecents(elephant) {
    function filterNullElephantIfNotFirst(elephantToFilter, index) {
      if (index === 0) return true;
      return elephantToFilter.pk != null;
    }

    if (!elephant) return;
    let recents = JSON.parse(localStorage.getItem('recentElephants')) || [];
    if (recents.length === 0) {
      recents.push(elephant);
    } else {
      recents.unshift(elephant);
      recents = recents
        .filter((recentElephant, index) => (
          recents.map(ele => ele.pk).indexOf(recentElephant.pk) === index))
        .filter((recentElephant, index) => filterNullElephantIfNotFirst(recentElephant, index));
      if (recents.length > maxNumberOfRecents + 1) {
        recents.pop();
      }
    }
    localStorage.setItem('recentElephants', JSON.stringify(recents));
  }

  parseRecentElephantsExcludingTheActiveElephant(recents) {
    return JSON.parse(recents).slice(1);
  }

  render() {
    const {
      classes, width, logout, user,
    } = this.props;

    const { anchorEl } = this.state;
    const recentsJSON = localStorage.getItem('recentElephants');
    let recents;
    if (recentsJSON) recents = this.parseRecentElephantsExcludingTheActiveElephant(recentsJSON);

    return (
      <div className={classes.AccountAndRecents}>
        <Typography className={classes.LoggedInStatus}>

          <FontAwesomeIcon icon="user" style={{ marginRight: '3px', fontSize: '0.9em' }} />
          {isWidthUp('md', width) ? `${user.first_name} ${user.last_name}` : `${user.first_name}`}
        </Typography>
        <div className={classes.Buttons}>
          <Button
            aria-owns={anchorEl ? 'recents-menu' : null}
            aria-haspopup="true"
            onClick={this.openMenu}
            variant="contained"
            size={isWidthUp('md', width) ? 'medium' : 'small'}
            className={classes.Button}
            color="secondary"
          >
            <FontAwesomeIcon icon="clock" className={classes.Icon} />
            {isWidthUp('md', width) && (
            <Typography className={classes.buttonLabel} noWrap color="primary">
              {'Recents'}
            </Typography>
            )}
          </Button>

          <Button
            onClick={logout}
            variant="contained"
            color="secondary"
            size={isWidthUp('md', width) ? 'medium' : 'small'}
            className={classes.Button}
          >
            <FontAwesomeIcon icon="door-open" className={classes.Icon} />
            {isWidthUp('md', width) && (
            <Typography className={classes.buttonLabel} noWrap color="primary">
              {'Log out'}
            </Typography>
            )}
          </Button>


          <Menu
            id="recents-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.closeMenu}
          >
            {recents && recents.length > 0
              ? (
                recents.map((recentEntry, index) => (
                  <MenuItem
                    key={recentEntry.pk}
                    onClick={this.handleRecentClicked}
                    recent-index={index + 1}
                  >
                    {`${recentEntry.num || 'UKN'} - ${recentEntry.name || 'UKN'}`}
                  </MenuItem>))
              )
              : (
                <MenuItem>
                  {'No recent elephants'}
                </MenuItem>
              )
          }
          </Menu>
        </div>
      </div>
    );
  }
}

AccountAndRecents.defaultProps = {
  elephant: null,
};

AccountAndRecents.propTypes = {
  classes: PropTypes.shape().isRequired,
  width: PropTypes.string.isRequired,
  updateActiveElephant: PropTypes.func.isRequired,
  elephant: PropTypes.shape(),
  user: PropTypes.shape().isRequired,
  logout: PropTypes.func.isRequired,
};

export default withUser(withWidth()(withStyles(styles)(AccountAndRecents)));



// WEBPACK FOOTER //
// ./src/layout/top-panel/AccountAndRecents.jsx